import { Client } from "@microsoft/microsoft-graph-client"
import { UserAgentApplication } from "msal"
import { config } from "../../config"


const userAgentApplication = new UserAgentApplication({
    auth: {
      clientId: config.clientId,
      redirectUri: config.redirectUri,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: true,
    },
  })

  const getAuthenticatedClient = accessToken => {
    const client = Client.init({
      authProvider: done => {
        done(null, accessToken.accessToken)
      },
    })
    return client
  }


export const handleSSOLogin = async (loginState,setLoginState,dispatchSSOUserProfiletoAPI) => {
    try {
      await userAgentApplication.loginPopup({
        scopes: config.scopes,
        prompt: "select_account",
      })
      await getUserProfile(setLoginState,dispatchSSOUserProfiletoAPI)
    } catch (err) {
      var error = {}
      if (typeof err === "string") {
        let errParts = err.split("|")
        error =
          errParts.length > 1
            ? {
                message: errParts[1],
                debug: errParts[0],
              }
            : {
                message: err,
              }
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        }
        console.log("Login User Error ----------->", error.message)
        setLoginState({
          isAuthenticated: false,
          user: {},
          error: error,
        })
      }
    }
  }

  const getUserProfile = async (setLoginState,dispatchSSOUserProfiletoAPI) => {
    try {
      // Get the access token silently
      // If the cache contains a non-expired token, this function
      // will just return the cached token. Otherwise, it will
      // make a request to the Azure OAuth endpoint to get a token

      console.log("In GetUSer Profile")

      var accessToken = await userAgentApplication.acquireTokenSilent({
        scopes: ["user.read"],
      })

      if (accessToken) {
        
        console.log("AccessToken----------->", accessToken)

        // Get the user's profile from Graph
        var user = await getUserDetails(accessToken)
        var data = {
          contactName: user?.displayName,
          email: user?.mail,
          password: "",
          authtype: "Microsoft",
          // Send the Graph access token (NOT the Azure object id): the API
          // validates it against Graph /me before issuing a session.
          authToken: accessToken?.accessToken,
            platform:'web'
        }
console.log('user',user)
        // var data = {
        //      contactName: "Vengateswaran",
        //   email: "vengateswaran@tendersoftware.in",
        //   password: "1234",
        //   authtype: "Microsoft",
        //   authToken: "cdfca79f-87e6-4419-8b16-dca31t00c787",
        //   platform:'web'

        // }

        // dispatch(socialLogin(data, props.history))
      
        dispatchSSOUserProfiletoAPI(data)

        // dispatch(socialLogin(data, props.history))

        setLoginState({
          isAuthenticated: true,
          user: {
            displayName: user.displayName,
            email: user.mail || user.userPrincipalName,
            givenName: user.givenName,
            surname: user.surname,
          },
          error: null,
        })
      }
    } catch (err) {
      let error = {}
      if (typeof err === "string") {
        let errParts = err.split("|")
        error =
          errParts.length > 1
            ? {
                message: errParts[1],
                debug: errParts[0],
              }
            : { message: err }
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        }
      }

      console.log("Error ", error)

      setLoginState({
        isAuthenticated: false,
        user: {},
        error: error,
      })
    }
  }

  const getUserDetails = async accessToken => {
    const client = getAuthenticatedClient(accessToken)
    const user = await client.api("/me").get()
    return user
  }
